import { render, staticRenderFns } from "./ItemDesktop.vue?vue&type=template&id=4c19a02a"
import script from "./ItemDesktop.vue?vue&type=script&lang=js"
export * from "./ItemDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports